<script>
export default {
  props: {
    content: {
      type: Object
    }
  },
  computed: {
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : Fandom.retrieveFromGlobalState("one_col_text_width", 8);
      return [
        `col-lg-${columnWidth}`,
        `text-${this.content.text_align}`
      ];
    },
  }
};
</script>

<template>
  <div :style="{ 'background-color': content.header_background_color ? content.header_background_color : 'inherit' }" page-header-component>
    <div class="container">
      <div class="row py-4 justify-content-center">
        <div :class="columnClasses">
          <p class="category" v-if="content.category">{{content.category}}</p>
          <component :is="content.title_tag || 'h1'" class="display-2" v-if="content.title">{{content.title}}</component>
          <component :is="content.description_tag || 'div'" class="h2" v-html="content.description" v-if="content.description"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
</style>